module.exports = __webpack_public_path__ + "img/menucn_5_2.f6178694.svg";